import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Table,
    RadioGroup, FormControlLabel, Radio, IconButton, Divider,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {
    useGetDisciplineGroupJournalBasicsQuery,
} from "../store/journal/journalApi";
import {
    useGetThemesListQuery
} from "../store/themeplan/themePlanApi";
import "./styles/printingstyles.scss";
import DeleteIcon from "@mui/icons-material/Delete";
import copyObject from "../utils/copyObject";
import {ArrowDownward, ArrowUpward} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import MenuItem from "@mui/material/MenuItem";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PrintIcon from "@mui/icons-material/Print";
import {useGetTechMapQuery} from "../store/grc/grcApi";

export default function PrintTechMapPage() {
    const {courseId, disciplineId, virtualGroupId, viewMode} = useParams();
    const navigate = useNavigate();
    const delimiterStyle = {'borderRight': '0.5px solid black'};
    const totalStyle = {'background': '#caccd1', "color": 'black', 'fontWeight': 'bold'};
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [redrawBeforeInitDone, setRedrawBeforeInitDone] = useState(false);
    const [initDone, setInitDone] = useState(false);
    const [secondSemesterPosition, setSecondSemesterPosition] = useState(0);
    const [refresh, setRefresh] = useState(false);
    const [disciplineRequirements, setDisciplineRequirements] = useState([]);
    const [printInitialized, setPrintInitialized] = useState(false);
    const {data: themesData} = useGetThemesListQuery({courseId, disciplineId, virtualGroupId});
    const {data: techMapData} = useGetTechMapQuery({courseId, disciplineId, virtualGroupId});
    const {data: disciplineData} = useGetDisciplineGroupJournalBasicsQuery({courseId, disciplineId});
    const [copyOfThemes, setCopyOfThemes] = useState([]);
    const [range, setRange] = useState({});
    const examTaskTypes = [
        {id: 1, title: 'Теоретический вопрос'},
        {id: 2, title: 'Задание'}
    ];
    const [examTasks, setExamTasks] = useState([]);
    const [attestationRange, setAttestationRange] = useState({
        attestationConversionGrade5From: 0,
        attestationConversionGrade4From: 0,
        attestationConversionGrade3From: 0,
        attestationConversionGrade2From: 0,
        attestationConversionGrade5To: 0,
        attestationConversionGrade4To: 0,
        attestationConversionGrade3To: 0,
        attestationConversionGrade2To: 0,
    });
    
    useEffect(() => {
        if (initDone)
            return;
        
        if (techMapData) {
            range.grade5From = techMapData?.data?.conversionRangeGrade5From ?? 0;
            range.grade5To = techMapData?.data?.conversionRangeGrade5To ?? 0;
            range.grade4From = techMapData?.data?.conversionRangeGrade4From ?? 0;
            range.grade4To = techMapData?.data?.conversionRangeGrade4To ?? 0;
            range.grade3From = techMapData?.data?.conversionRangeGrade3From ?? 0;
            range.grade3To = techMapData?.data?.conversionRangeGrade3To ?? 0;
            range.grade2From = techMapData?.data?.conversionRangeGrade2From ?? 0;
            range.grade2To = techMapData?.data?.conversionRangeGrade2To ?? 0;
            attestationRange.attestationConversionGrade5From = techMapData?.data?.attestationConversionGrade5From ?? 0;
            attestationRange.attestationConversionGrade4From = techMapData?.data?.attestationConversionGrade4From ?? 0;
            attestationRange.attestationConversionGrade3From = techMapData?.data?.attestationConversionGrade3From ?? 0;
            attestationRange.attestationConversionGrade2From = techMapData?.data?.attestationConversionGrade2From ?? 0;
            attestationRange.attestationConversionGrade5To = techMapData?.data?.attestationConversionGrade5To ?? 0;
            attestationRange.attestationConversionGrade4To = techMapData?.data?.attestationConversionGrade4To ?? 0;
            attestationRange.attestationConversionGrade3To = techMapData?.data?.attestationConversionGrade3To ?? 0;
            attestationRange.attestationConversionGrade2To = techMapData?.data?.attestationConversionGrade2To ?? 0;
            setDisciplineRequirements(techMapData?.data?.activities ? copyObject(techMapData?.data?.activities) : []);
            setExamTasks(techMapData?.data?.examTasks ? copyObject(techMapData?.data?.examTasks) : []);
        }

        if (copyOfThemes.length === 0) {
            if (themesData !== undefined && themesData) {
                setCopyOfThemes(copyObject(themesData.data));
            }
        }
        
        if (themesData && techMapData?.data && disciplineData) {
            if (techMapData.data.themesOfFirstPartOfSemester !== null) {
                let stopAllLoops = false;
                for (let i = 0; i < copyOfThemes.length; i += 1) {
                    for (let j = 0; j < copyOfThemes[i].lessonTypes.length; j += 1) {
                        if (techMapData.data.themesOfFirstPartOfSemester?.find((item) => copyOfThemes[i].lessonTypes[j].themePlanIds.find((tp) => tp === item) !== undefined) !== undefined) {
                            if (i > secondSemesterPosition) {
                                setSecondSemesterPosition(i > 0 ? i : 0);
                            }
                            stopAllLoops = true;
                            // break;
                        }
                    }

                    if (false && stopAllLoops)
                        break;
                }
            }

            // setSecondSemesterPosition(techMapData?.data?.secondSemesterStartsFromOrderNumber ?? 0);

            copyOfThemes.forEach(theme => {
                const themeActivity = techMapData?.data?.themes?.find((item) =>
                    theme.lessonTypes.find(lt =>
                        lt.themePlanIds.find(tpi =>
                            item.lessonTypes.find(tmlt =>
                                tmlt.themePlanIds.find(tmtpi =>
                                    tmtpi === tpi)
                                !== undefined)
                            !== undefined)
                        !== undefined)
                    !== undefined);

                theme.labsGrade = themeActivity?.labsGrade ?? 0;
                theme.lecturesGrade = themeActivity?.lecturesGrade ?? 0;
                theme.seminarsGrade = themeActivity?.seminarsGrade ?? 0;
                theme.labsHours = themeActivity?.labsHours ?? 0;
                theme.lecturesHours = themeActivity?.lecturesHours ?? 0;
                theme.seminarsHours = themeActivity?.seminarsHours ?? 0;
                theme.activities = themeActivity?.activities?.map((act) => {
                    return {
                        points: act.points.toString(), // .toString(),
                        association: disciplineRequirements?.find((dr) => dr.key === act.association.key),
                    }
                }) ?? [];
            });

            if (redrawBeforeInitDone)
                setInitDone(true);

            setRedrawBeforeInitDone(true);
            
            if (viewMode !== '1') {
                setTimeout(() => {
                    window.print();
                    window.close();
                }, 1000);
            }
        }
    }, [themesData, techMapData, disciplineData, disciplineRequirements, redrawBeforeInitDone]);
    
    
    function onBeforePrint() {
        document.querySelectorAll('a').forEach((link) => {link.style.display = 'none'});
    }
    
    function onAfterPrint() {
        document.querySelectorAll('a').forEach((link) => {link.style.display = ''});
    }

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function sumDisciplineRequirementsMaxPoints() {
        let sum = 0;
        disciplineRequirements?.forEach((dr) => {
            if (dr.maxPoints) {
                sum += parseFloat(dr.maxPoints.toString());
            }
        });

        return sum;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }
    function attendanceEditField(property, item) {
        return <Typography>{item[property]}</Typography>
    }

    function sumAttendanceGradeForRow(item) {
        const lecturesGrade = parseFloat(item.lecturesGrade !== undefined && item.lecturesGrade !== null ? item.lecturesGrade : '0');
        const seminarsGrade = parseFloat(item.seminarsGrade !== undefined && item.seminarsGrade !== null ? item.seminarsGrade : '0');
        const labsGrade = parseFloat(item.labsGrade !== undefined && item.labsGrade !== null ? item.labsGrade : '0');

        return (lecturesGrade + seminarsGrade + labsGrade).toFixed(2);
    }

    function sumAttendanceGradeFromTo(from, to) {
        const sum = parseFloat(sumAttendanceByProperty('lecturesGrade', from, to))
            + parseFloat(sumAttendanceByProperty('seminarsGrade', from, to))
            + parseFloat(sumAttendanceByProperty('labsGrade', from, to));

        return sum === undefined ? 0 : parseFloat(sum.toString()).toFixed(2);
    }

    function sumAttendanceByProperty(property, from, to) {
        let sum = 0;
        copyOfThemes.slice(from, to + 1).forEach((item) => {
            sum += parseFloat(item[property] !== undefined && item[property] !== null ? item[property] : '0');
        })

        return sum.toFixed(2);
    }

    function sumHoursByDisciplineRequirement(requirementItem, semesterPart, theme) {
        if (theme) {
            return sumHoursByDisciplineRequirementTheme(theme);
        }

        let sum = 0;
        copyOfThemes?.slice(semesterPart === 1 || semesterPart === null ? 0 : secondSemesterPosition + 1,
            semesterPart === 1 && semesterPart !== null ? secondSemesterPosition + 1 : copyOfThemes.length)
            .forEach((theme) => {
                const requirements = theme.activities?.filter((item) => requirementItem === null || item.association?.key === requirementItem.key);
                requirements?.forEach((item) => {
                    sum += parseFloat(item.points ?? '0');
                });
            });

        return sum.toFixed(2);
    }

    function totalPoints() {
        const attGrade = parseFloat(sumAttendanceGradeFromTo(0, secondSemesterPosition ?? 0));
        const gradePoints = sumDisciplineRequirementsMaxPoints();
        return parseFloat((attGrade + gradePoints).toString()).toFixed(2);
    }

    function getSemesterPointsRangeField(property) {
        // const sumOfPoints = totalPoints();
        return <Typography>
            {attestationRange[property]}
        </Typography>
    }

    function sumHoursByDisciplineRequirementTheme(theme) {
        let sum = 0;
        const requirements = theme.activities;
        requirements?.forEach((item) => {
            sum += parseFloat(item.points ?? '0');
        });

        return sum.toFixed(2);
    }

    return (
        <Container>
            <PageTitle title={`Технологическая карта по дисциплине`}/>
            
            {!disciplineData || !themesData || !techMapData ? <CircularProgress/> : <></>}
            {viewMode === '1'
            ? <div className={'app-header'}>
                    <br />
                    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                        <Button startIcon={<ArrowBackIosIcon/>} onClick={() => navigate(-1)}>Назад</Button>
                        <Button startIcon={<PrintIcon/>} onClick={() => window.print()}>Печать</Button>
                    </Stack>
                </div>
            : <></>}
            <Typography variant={'h4'}>Технологическая карта по дисциплине {disciplineData?.disciplineName}</Typography>
            <Typography>Для студентов{virtualGroupId > 0 ? ' сводной группы' : `, обучающихся по направлению ${disciplineData?.courseName}`}</Typography>
            <br />
            <Typography variant={'h5'}>Требования по дисциплине</Typography>
            <Table size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell align={'center'}>№</TableCell>
                        <TableCell align={'center'}>Активность</TableCell>
                        <TableCell align={'center'}>Баллы</TableCell>
                        <TableCell align={'center'}>Комментарии</TableCell>
                        <TableCell align={'center'}>Действия по отработке</TableCell>
                        <TableCell align={'center'}>Макс. кол-во баллов</TableCell>
                        <TableCell align={'center'}>Тип контроля</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {disciplineRequirements?.map((item, index) => {
                        return <TableRow>
                            <TableCell align={'center'}>{index + 1}</TableCell>
                            <TableCell align={'center'}>
                                <Typography fontSize={'small'}>{item.gradeTypeTitle}</Typography>
                            </TableCell>
                            <TableCell align={'center'}>
                                <Typography fontSize={'small'}>{item.points}</Typography>
                            </TableCell>
                            <TableCell align={'center'}>
                                <Typography fontSize={'smaller'}>{item.comment}</Typography>
                            </TableCell>
                            <TableCell align={'center'}>
                                <Typography fontSize={'smaller'}>{item.workOff}</Typography>
                            </TableCell>
                            <TableCell align={'center'}>
                                <Typography fontSize={'smaller'}>{item.maxPoints}</Typography>
                            </TableCell>
                            <TableCell align={'center'}>
                                <Typography fontSize={'smaller'}>
                                    {item.controlType === 0
                                    ? 'Аудиторная контактная работа обучающегося'
                                    : item.controlType === 1
                                        ? 'Контроль самостоятельной работы обучающегося'
                                        : '-'
                                    }
                                </Typography>
                            </TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>
            
            <br />
            <br />
            {/* <div className={'page-break'}/> */}
            
            <Typography variant={'h5'}>Контроль посещаемости</Typography>
            <Table size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell align={'center'}>№ п/п</TableCell>
                        <TableCell align={'center'}>Наименование тем дисциплины</TableCell>
                        <TableCell align={'center'}>Лекции, часов в РП</TableCell>
                        <TableCell align={'center'}>Итого баллов</TableCell>
                        <TableCell align={'center'}>Практические занятия, часов в РП</TableCell>
                        <TableCell align={'center'}>Итого баллов</TableCell>
                        <TableCell align={'center'}>Лабораторные занятия, часов в РП</TableCell>
                        <TableCell align={'center'}>Итого баллов</TableCell>
                        <TableCell align={'center'} style={totalStyle}>ВСЕГО БАЛЛОВ</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={9} align={'center'}>
                            <Typography fontWeight={'bold'}>Первая половина семестра</Typography>
                        </TableCell>
                    </TableRow>
                    {copyOfThemes?.map((item, index) => {
                        return <>
                            <TableRow>
                                <TableCell align={'center'}>{index + 1}</TableCell>
                                <TableCell align={'center'}>
                                    <Typography fontSize={'small'}>{item.theme}</Typography>
                                </TableCell>
                                <TableCell
                                    align={'center'}>{attendanceEditField('lecturesHours', item)}</TableCell>
                                <TableCell
                                    align={'center'}>{attendanceEditField('lecturesGrade', item)}</TableCell>
                                <TableCell
                                    align={'center'}>{attendanceEditField('seminarsHours', item)}</TableCell>
                                <TableCell
                                    align={'center'}>{attendanceEditField('seminarsGrade', item)}</TableCell>
                                <TableCell
                                    align={'center'}>{attendanceEditField('labsHours', item)}</TableCell>
                                <TableCell
                                    align={'center'}>{attendanceEditField('labsGrade', item)}</TableCell>
                                <TableCell align={'center'}
                                           style={totalStyle}>{sumAttendanceGradeForRow(item)}</TableCell>
                            </TableRow>
                            {secondSemesterPosition === index || (index === copyOfThemes.length - 1 && secondSemesterPosition > copyOfThemes.length - 1)
                                ? <>
                                    <TableRow>
                                        <TableCell align={'center'} colSpan={2} style={totalStyle}>
                                            <Typography fontSize={'smaller'} fontWeight={'bold'}>Общее количество аудиторных занятий за 1 половину семестра</Typography>
                                        </TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('lecturesHours', 0, index)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('lecturesGrade', 0, index)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('seminarsHours', 0, index)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('seminarsGrade', 0, index)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('labsHours', 0, index)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('labsGrade', 0, index)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceGradeFromTo(0, index)}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell colSpan={9} align={'center'}>
                                            <Stack>
                                                <Stack direction={'row'} alignItems={'center'}
                                                       justifyContent={'center'}>
                                                    <Typography fontWeight={'bold'}>Вторая половина
                                                        семестра</Typography>
                                                </Stack>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                </>
                                : <></>}
                        </>
                    })}

                    <TableRow>
                        <TableCell align={'center'} colSpan={2} style={totalStyle}>
                            <Typography fontSize={'smaller'} fontWeight={'bold'}>Общее количество аудиторных занятий за 2 половину семестра</Typography>
                        </TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('lecturesHours', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('lecturesGrade', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('seminarsHours', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('seminarsGrade', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('labsHours', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('labsGrade', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceGradeFromTo(secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell align={'center'} colSpan={2} style={totalStyle}>
                            <Typography fontSize={'smaller'} fontWeight={'bold'}>Всего посещение аудиторных занятий</Typography>
                        </TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('lecturesHours', 0, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('lecturesGrade', 0, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('seminarsHours', 0, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('seminarsGrade', 0, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('labsHours', 0, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceByProperty('labsGrade', 0, copyOfThemes.length - 1)}</TableCell>
                        <TableCell align={'center'}
                                   style={totalStyle}>{sumAttendanceGradeFromTo(0, copyOfThemes.length - 1)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            
            <br />
            <br />

            { /*
            <Typography variant={'h5'}>Контроль успеваемости</Typography>

            <Table size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell align={'center'} rowSpan={2}>№ п/п</TableCell>
                        <TableCell align={'center'} rowSpan={2} style={delimiterStyle}>
                            Наименование тем дисциплины</TableCell>
                        {disciplineRequirements?.filter((item) => !item.controlType).length > 0
                            ?
                            <TableCell align={'center'}
                                       colSpan={disciplineRequirements?.filter((item) => !item.controlType).length}
                                       style={delimiterStyle}>
                                Аудиторная контактная работа обучающегося
                            </TableCell>
                            : <></>}

                        {disciplineRequirements?.filter((item) => item.controlType).length > 0
                            ?
                            <TableCell align={'center'}
                                       colSpan={disciplineRequirements?.filter((item) => item.controlType).length}>
                                Контроль самостоятельной работы обучающегося</TableCell>
                            : <></>}
                        <TableCell align={'center'}
                                   rowSpan={2}
                                   style={totalStyle}>ВСЕГО</TableCell>
                    </TableRow>
                    <TableRow>
                        {disciplineRequirements?.filter((item) => !item.controlType).map((item, index) => {
                            return <TableCell align={'center'}
                                              style={index === disciplineRequirements?.filter((item) => !item.controlType).length - 1 ? delimiterStyle : {}}>{item.gradeTypeTitle}</TableCell>
                        })}

                        {disciplineRequirements?.filter((item) => item.controlType).map((item) => {
                            return <TableCell align={'center'}>{item.gradeTypeTitle}</TableCell>
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={9} align={'center'}>
                            <Typography fontWeight={'bold'}>Первая половина
                                семестра</Typography>
                        </TableCell>
                    </TableRow>
                    {copyOfThemes?.map((item, index) => {
                        return <>
                            <TableRow>
                                <TableCell align={'center'}>{index + 1}</TableCell>
                                <TableCell align={'center'}>{item.theme}</TableCell>
                                {disciplineRequirements?.filter((req) => !req.controlType).map((req) => {
                                    return <TableCell align={'center'}>
                                        <Typography fontSize={'small'}>
                                            {item.activities?.find((activity) => activity.association?.key === req.key)?.points ?? '0'}
                                        </Typography>
                                    </TableCell>
                                })}

                                {disciplineRequirements?.filter((req) => req.controlType).map((req) => {
                                    return <TableCell align={'center'}>
                                        <Typography fontSize={'small'}>{item.activities?.find((activity) => activity.association?.key === req.key)?.points ?? '0'}</Typography>
                                    </TableCell>
                                })}

                                <TableCell align={'center'}
                                           style={totalStyle}>{sumHoursByDisciplineRequirement(null, null, item)}</TableCell>
                            </TableRow>
                            {secondSemesterPosition === index || (index === copyOfThemes.length - 1 && secondSemesterPosition > copyOfThemes.length - 1)
                                ? <>
                                    <TableRow>
                                        <TableCell align={'center'} colSpan={2}
                                                   style={totalStyle}>
                                            <Typography fontWeight={'bold'} fontSize={'small'}>Итого 1 половина семестра</Typography>
                                        </TableCell>
                                        {disciplineRequirements?.filter((req) => !req.controlType).map((req) => {
                                            return <TableCell align={'center'}
                                                              style={totalStyle}>{sumHoursByDisciplineRequirement(req, 1, null)}</TableCell>
                                        })}

                                        {disciplineRequirements?.filter((req) => req.controlType).map((req) => {
                                            return <TableCell align={'center'}
                                                              style={totalStyle}>{sumHoursByDisciplineRequirement(req, 1, null)}</TableCell>
                                        })}

                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumHoursByDisciplineRequirement(null, 1, null)}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell colSpan={9} align={'center'}>
                                            <Stack direction={'row'} alignItems={'center'}
                                                   justifyContent={'center'}>
                                                <Typography fontWeight={'bold'}>Вторая половина
                                                    семестра</Typography>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                </>
                                : <></>}
                        </>
                    })}

                    <TableRow>
                        <TableCell align={'center'} colSpan={2} style={totalStyle}>
                            <Typography fontWeight={'bold'} fontSize={'small'}>Итого 2 половина семестра</Typography>
                        </TableCell>
                        {disciplineRequirements?.filter((req) => !req.controlType).map((req) => {
                            return <TableCell align={'center'}
                                              style={totalStyle}>{sumHoursByDisciplineRequirement(req, 2, null)}</TableCell>
                        })}

                        {disciplineRequirements?.filter((req) => req.controlType).map((req) => {
                            return <TableCell align={'center'}
                                              style={totalStyle}>{sumHoursByDisciplineRequirement(req, 2, null)}</TableCell>
                        })}

                        <TableCell align={'center'}
                                   style={totalStyle}>{sumHoursByDisciplineRequirement(null, 2, null)}</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell align={'center'} colSpan={2} style={totalStyle}>
                            <Typography fontWeight={'bold'} fontSize={'small'}>Всего за семестр</Typography>
                        </TableCell>
                        {disciplineRequirements?.filter((req) => !req.controlType).map((req) => {
                            return <TableCell align={'center'}
                                              style={totalStyle}>{sumHoursByDisciplineRequirement(req, null, null)}</TableCell>
                        })}

                        {disciplineRequirements?.filter((req) => req.controlType).map((req) => {
                            return <TableCell align={'center'}
                                              style={totalStyle}>{sumHoursByDisciplineRequirement(req, null, null)}</TableCell>
                        })}

                        <TableCell align={'center'}
                                   style={totalStyle}>{sumHoursByDisciplineRequirement(null, null, null)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            
            <br />
            <br />
            
            */ }

            <Typography id="modal-modal-title" variant="h6" component="h2" textAlign={'center'}>
                Преобразование баллов для рубежной аттестации
            </Typography>

            <Table size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell align={'right'}>100-балльная система
                            <br />От - До</TableCell>
                        <TableCell align={'left'}>5-балльная система</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell align={'right'}>
                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                   alignItems={'center'}>
                                {getSemesterPointsRangeField('attestationConversionGrade5From')}
                                <strong>-</strong>
                                {getSemesterPointsRangeField('attestationConversionGrade5To')}
                            </Stack>
                        </TableCell>
                        <TableCell align={'left'}>Отлично / "зачтено"</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align={'right'}>
                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                   alignItems={'center'}>
                                {getSemesterPointsRangeField('attestationConversionGrade4From')}
                                <strong>-</strong>
                                {getSemesterPointsRangeField('attestationConversionGrade4To')}
                            </Stack>
                        </TableCell>
                        <TableCell align={'left'}>Хорошо / "зачтено"</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align={'right'}>
                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                   alignItems={'center'}>
                                {getSemesterPointsRangeField('attestationConversionGrade3From')}
                                <strong>-</strong>
                                {getSemesterPointsRangeField('attestationConversionGrade3To')}
                            </Stack>
                        </TableCell>
                        <TableCell align={'left'}>Удовлетворительно / "зачтено"</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align={'right'}>
                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                   alignItems={'center'}>
                                {getSemesterPointsRangeField('attestationConversionGrade2From')}
                                <strong>-</strong>
                                {getSemesterPointsRangeField('attestationConversionGrade2To')}
                            </Stack>
                        </TableCell>
                        <TableCell align={'left'}>Неудовлетворительно</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            
            <br />
            <br />

            <Typography variant={'h5'}>Экзаменационный билет</Typography>

            <Table size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell align={'center'} width={100}>Номер вопроса</TableCell>
                        <TableCell align={'center'} width={300}>Тип</TableCell>
                        <TableCell align={'left'}>Кол-во баллов</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {examTasks.sort((l,r) => l.orderNumber > r.orderNumber ? 1 : -1).map((item, index) => {
                        return <TableRow>
                            <TableCell align={'center'}><strong>{index + 1}</strong></TableCell>
                            <TableCell align={'center'}>
                                <Typography fontSize={'small'}>
                                    {examTaskTypes.find((type) => type.id === item.taskType)?.title}
                                </Typography>
                            </TableCell>
                            <TableCell align={'left'}>
                                <Typography fontSize={'small'}>
                                    {item.points}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>
            
            <br />
            <br />

            <Table size={'small'}>
                <TableBody>
                    <TableRow>
                        <TableCell rowSpan={2} style={{'fontWeight': 'bold'}}>Максимальное
                            количество баллов по дисциплине</TableCell>
                        <TableCell align={'center'}
                                   style={{'fontWeight': 'bold'}}>Норматив</TableCell>
                        <TableCell align={'center'} style={{'fontWeight': 'bold'}}>По
                            дисциплине</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align={'center'} style={{'fontWeight': 'bold'}}>100</TableCell>
                        <TableCell align={'center'} style={{'fontWeight': 'bold'}}>100</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>посещение лекционных и практических занятий</TableCell>
                        <TableCell align={'center'}>
                            <strong>от 8 до 20</strong>
                        </TableCell>
                        <TableCell align={'center'}>
                            <Typography fontSize={'small'}>
                                {sumAttendanceGradeFromTo(0, copyOfThemes.length - 1)}
                            </Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>текущий контроль (аудиторная и самостоятельная работа)</TableCell>
                        <TableCell align={'center'}>
                            <Stack direction={'row'} spacing={1}>
                                <strong>от 44 до 56</strong>
                            </Stack>
                        </TableCell>
                        <TableCell align={'center'}>
                            {sumDisciplineRequirementsMaxPoints()}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography fontSize={'small'} fontWeight={'bold'}>
                                Итого без промежуточной аттестации
                            </Typography>
                        </TableCell>
                        <TableCell align={'center'} style={{'fontWeight': 'bold'}}>64</TableCell>
                        <TableCell align={'center'} style={{'fontWeight': 'bold'}}>
                            <Typography color={parseFloat(sumAttendanceGradeFromTo(0, copyOfThemes.length - 1)) + sumDisciplineRequirementsMaxPoints() > 64 ? 'red' : 'black'}
                                        fontWeight={'bold'}
                                        fontSize={'medium'}>
                                {(parseFloat(sumAttendanceGradeFromTo(0, copyOfThemes.length - 1)) + sumDisciplineRequirementsMaxPoints()).toFixed(2)}
                            </Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography fontSize={'small'} fontWeight={'bold'}>
                                Дополнительные баллы по распоряжению деканата (НО! итоговое количество баллов у обучающегося не должно превысить 100)
                            </Typography>
                        </TableCell>
                        <TableCell align={'center'} style={{'fontWeight': 'bold'}}>0-15</TableCell>
                        <TableCell align={'center'} style={{'fontWeight': 'bold'}}>0</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            
            <br />
            
            <br />
            <Typography fontWeight={'bold'} 
                        fontSize={'small'}
                        align={'center'}>
                Максимальное количество баллов по контролю посещаемости и текущему контролю успеваемости обучающегося - 64.
            </Typography>
            <Typography align={'center'} fontSize={'small'}>Итоговая сумма баллов, полученная обучающимся на промежуточной
                аттестации (зачете, экзамене) и по результатам посещаемости и текущего контроля
                успеваемости в семестре, преобразуется в пятибалльную систему оценок в соответствии с
                порядком перевода 100-балльной оценки в 5-балльную:</Typography>
            <Table size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell align={'right'}>
                            <Typography fontWeight={'bold'} fontSize={'small'}>100-балльная система
                                <br/>От - До</Typography>
                        </TableCell>
                        <TableCell align={'left'}><Typography fontWeight={'bold'} fontSize={'small'}>5-балльная
                            система</Typography></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell align={'right'}>
                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                   alignItems={'center'}>
                                {range.grade5From}
                                <strong> - </strong>
                                {range.grade5To}
                            </Stack>
                        </TableCell>
                        <TableCell align={'left'}>Отлично / "зачтено"</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align={'right'}>
                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                   alignItems={'center'}>
                                {range.grade4From}
                                <strong> - </strong>
                                {range.grade4To}
                            </Stack>
                        </TableCell>
                        <TableCell align={'left'}>Хорошо / "зачтено"</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align={'right'}>
                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                   alignItems={'center'}>
                                {range.grade3From}
                                <strong> - </strong>
                                {range.grade3To}
                            </Stack>
                        </TableCell>
                        <TableCell align={'left'}>Удовлетворительно / "зачтено"</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align={'right'}>
                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                   alignItems={'center'}>
                                {range.grade2From}
                                <strong> - </strong>
                                {range.grade2To}
                            </Stack>
                        </TableCell>
                        <TableCell align={'left'}>Неудовлетворительно</TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            {viewMode === '1'
            ? <br />
            : <></>}
        </Container>
    );
}